"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTaskCategoriesQuery = exports.taskCategoryApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
exports.taskCategoryApi = (0, react_1.createApi)({
    reducerPath: "taskCategoryApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["task-category"],
    endpoints: function (builder) { return ({
        getTaskCategories: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/task-category"),
            providesTags: ["task-category"],
        }),
    }); },
});
exports.useGetTaskCategoriesQuery = exports.taskCategoryApi.useGetTaskCategoriesQuery;
